import { useMemo } from 'react'
import { DeadSpaceRange, findActivityInDeadSpaceRange, getDeadSpaceRanges } from './activityUtils'
import { ProcessedRRWebEvents } from './rrweb/types'
import { ProcessedActivity } from '../../../api/models'

export type UseVideoEmptyStateResult = {
  labeledActivity: ProcessedActivity | undefined
  activeDeadSpaceRange: DeadSpaceRange | undefined
}

export const useVideoEmptyState = (
  processedRRWebEvents: ProcessedRRWebEvents,
  processedActivities: ProcessedActivity[],
  currentTimeInSeconds: number
): UseVideoEmptyStateResult => {
  const deadSpaceRanges = useMemo(() => getDeadSpaceRanges(processedRRWebEvents), [processedRRWebEvents])
  const activeDeadSpaceRange = useMemo(
    () =>
      deadSpaceRanges.find(range => currentTimeInSeconds >= range.relativeStartTimeSeconds && currentTimeInSeconds <= range.relativeEndTimeSeconds),
    [deadSpaceRanges, currentTimeInSeconds]
  )

  const currentActivity = useMemo(
    () =>
      processedActivities.find(
        activity => currentTimeInSeconds >= activity.relativeStartTimeSeconds && currentTimeInSeconds <= activity.relativeEndTimeSeconds
      ),
    [currentTimeInSeconds, processedActivities.find]
  )

  const labeledActivity = useMemo(
    () =>
      currentActivity?.hasVideo === false
        ? currentActivity
        : (activeDeadSpaceRange && findActivityInDeadSpaceRange(processedActivities, activeDeadSpaceRange)) || currentActivity,
    [activeDeadSpaceRange, currentActivity, processedActivities]
  )

  return {
    labeledActivity,
    activeDeadSpaceRange
  }
}
